export enum MessageType {
  Product = "Product",
  SalesOrder = "SalesOrder",
  SalesOrderCompleted = "SalesOrderCompleted",
  SalesOrderStatus = "SalesOrderStatus",
  PurchaseOrderStatus = "PurchaseOrderStatus",
  StockMutation = "StockMutation",
  Shipment = "Shipment",
  StockValue = "StockValue",
  StockDetail = "StockDetail",
  PurchaseOrder = "PurchaseOrder",
  Receipt = "Receipt",
  ShippingMethod = "ShippingMethod",
  WebshopSource = "WebshopSource",
  ReturnOrder = "ReturnOrder",
  ReturnReceipt = "ReturnReceipt",
}
